var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.themeModel || 'theme-dark', 'appRoot']},[_c('v-app',[_c('router-view',{attrs:{"id":"routerView"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }